<template>
  <div id="app">
    <notifications group="global" style="z-index:999999" position="bottom left"/>
    <div id="title-bar" v-if="authenticated && ['product', 'terms-conditions', 'privacy-policy', 'contact'].indexOf($route.name) < 0" style="z-index:1000">
      <div id="brand"><span><img src="/static/img/logo.png" alt="Shipping Board"></span></div>
      <user-area :user="user"></user-area>
    </div>
    <div id="app-content" :class="$route.name" >
      <span v-if="authenticated && ['product', 'terms-conditions', 'privacy-policy', 'contact'].indexOf($route.name) < 0">{{$t('hi')}}, {{user}}</span>
      <!-- <load-screen v-show="pageLoading"></load-screen> -->
      <transition name="fade" mode="out-in">
        <router-view
          @loaded="pageLoading=false"
          @loading="pageLoading=true"
          @next="nextPage()"
          :authenticated="authenticated"/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import LoadScreen from '@/components/LoadScreen'
import UserArea from '@/components/UserArea'
export default {
  name: 'app',
  components: {LoadScreen, UserArea},
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
      user: state => state.auth.user,
      kioskId: state => state.auth.kiosk.id,
      userData: state => state.auth.userData,
      notification: state => state.notification
    })
  },
  data () {
    return {
      pageLoading: false,
      pageIndex: 0,
      tokenLifetime: process.env.JWT_ACCESS_TOKEN_LIFETIME,
      pages: ['trucks', 'expeditions', 'receptions', 'indicators', 'alerts', 'critical-lines']
    }
  },
  watch: {
    notification (message) { if (!message) { return }; this.$notify(message) },
    authenticated (newVal) { if (newVal) { this.getUserData() } }
  },
  beforeMount () {
    this.getUserData()
  },
  mounted () {
    this.$nextTick(() => {
      this.timerRefresh = setInterval(() => {
        this.checkTokenValidate()
      }, 60000)
    })
    if (!localStorage.getItem('vueml-lang')) {
      localStorage.setItem('vueml-lang', 'es')
    } else {
      if (localStorage.getItem('vueml-lang') !== 'es' && localStorage.getItem('vueml-lang') !== 'en' && localStorage.getItem('vueml-lang') !== 'pt') {
        localStorage.setItem('vueml-lang', 'es')
      }
    }
    this.getUserData()
    this.$i18n.locale = localStorage.getItem('vueml-lang')
    if (this.authenticated) {
      this.getUserData()
    }
  },
  methods: {
    ...mapActions({
      refreshSso: 'auth/refreshSso'
    }),
    getUserData () {
      this.$store.dispatch('auth/user').then((response) => {
        if (response === 'token_not_valid') {
          this.$router.push('/login')
        }
      })
    },
    nextPage () {
      this.pageIndex++
      if (this.pageIndex > this.pages.length - 1) { this.pageIndex = 0 }
      this.$router.push(this.pages[this.pageIndex])
    },
    checkTokenValidate () {
      if (this.$route.name !== 'login' && process.JWT_LOGIN) {
        let token = localStorage.getItem('tokenJwt').toString()
        let jwt = JSON.parse(atob(token.split('.')[1]))
        let margin = (this.tokenLifetime / 10) * 3600 * 1000
        let currentDate = moment(new Date()) + margin
        if (currentDate > (jwt.exp * 1000)) {
          this.refreshSso({'refresh': localStorage.getItem('refresh')}).then((response) => {
            if (response === 'token_not_valid') {
              this.$router.push('/login')
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0
}
#app-content {
    padding-top: 70px;
}
.hi{
  padding-left: 1em;
}
img{
  max-width: 100%;
  height: auto;
  padding: 8px 20px 0 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue